// Use AIO build: it injects Notify/Block/etc CSS at runtime.
// The non-AIO dist build expects external CSS, but Sass leaves
// `@import 'notiflix/...css'` unresolved in the compiled stylesheet.
import Notiflix from "notiflix"

window.Notiflix = Notiflix
